export const getStatusBadgeStyle = (status) => {
    if (!status) return 'bg-gray-100 dark:bg-gray-900/30 text-gray-700 dark:text-gray-400';
    
    switch (status.toLowerCase()) {
        case 'active':
        case 'completed':
            return 'bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400';
        case 'cancelled':
        case 'rejected':
            return 'bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-400';
        case 'rented':
            return 'bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-400';
        case 'pending':
        case 'pendingapproval':
            return 'bg-yellow-100 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-400';
        case 'listed':
            return 'bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-400';
        case 'allocated':
            return 'bg-indigo-100 dark:bg-indigo-900/30 text-indigo-700 dark:text-indigo-400';
        case 'approved':
            return 'bg-emerald-100 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-400';
        default:
            return 'bg-gray-100 dark:bg-gray-900/30 text-gray-700 dark:text-gray-400';
    }
};
